import { Separator } from "@/components/ui/separator";
export default function PrivacyPolicyOverview() {
  return <section data-section-id="154108" id="privacy-overview" className="relative bg-background text-foreground overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">
      {}
      <div className="absolute inset-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/fiber_optic_node_xray.png)] bg-cover bg-center pointer-events-none mix-blend-overlay" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {}
        <span className="block font-sans text-foreground text-xl md:text-2xl mb-8 md:mb-12">
          LAST UPDATED 
        </span>

        {}
        <h1 className="font-sans font-bold text-5xl md:text-6xl lg:text-[64px] text-foreground leading-tight tracking-tight mb-12 lg:mb-20">
          Privacy Policy
        </h1>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-start-7 lg:col-span-6 bg-card/50 backdrop-blur-md rounded-xl border border-white/10 p-8">
            <p className="font-sans text-[18px] text-muted-foreground leading-relaxed">
              We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This policy outlines how we collect, use, and safeguard your data when you interact with our fiber optic network infrastructure and digital connectivity platforms.
            </p>
          </div>
        </div>
      </div>

      {}
      <Separator className="absolute bottom-0 left-0 w-full bg-border" />
    </section>;
}